import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import FloatingAlerts from '../../../shared/ui/floating-alerts/floating-alerts.jsx';
import LoadingContainer from '../../../shared/ui/loading-container/loading-container.jsx';

function CommissionPlansPageView({ rows, isLoading, error, reload, showAll, setShowAll }) {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div>
      <FloatingAlerts error={error} />
      <div className="app-page-header d-flex align-items-start justify-content-between gap-3">
        <div>
          <h2>{t('commissionPlans.title')}</h2>
          <p>{t('commissionPlans.subtitle')}</p>
        </div>
        <div className="d-flex gap-2">
          <button type="button" className="btn btn-outline-secondary" onClick={reload} disabled={isLoading}>{t('commissionPlans.refresh')}</button>
          <button type="button" className="btn btn-primary" onClick={() => navigate('/commission-plans/new')}>
            <i className="ti ti-plus me-1"></i>{t('commissionPlans.createPlan')}
          </button>
        </div>
      </div>
      <div className="widget-content searchable-container list">
        <div className="card card-body">
          <div className="d-flex justify-content-end mb-3">
            <div className="form-check form-switch mb-0 d-inline-flex align-items-center gap-2">
              <input
                className="form-check-input m-0"
                type="checkbox"
                id="commission-plans-show-all"
                checked={showAll}
                onChange={(e) => setShowAll(e.target.checked)}
                disabled={isLoading}
              />
              <label className="form-check-label" htmlFor="commission-plans-show-all">
                {t('commissionPlans.showAll')}
              </label>
            </div>
          </div>
          <LoadingContainer isLoading={isLoading} hasData={rows.length > 0}>
            <table className="table search-table align-middle text-nowrap mb-0">
              <thead className="header-item">
                <tr>
                  <th>{t('common.name')}</th>
                  <th>{t('commissionPlans.maxDepth')}</th>
                  <th>{t('commissionPlans.default')}</th>
                  <th>{t('commissionPlans.active')}</th>
                  <th>{t('commissionPlans.tiers')}</th>
                  <th>{t('common.date')}</th>
                </tr>
              </thead>
              <tbody>
                {!isLoading && rows.length === 0 ? (
                  <tr><td colSpan="6" className="text-center text-muted">{t('commissionPlans.noPlansFound')}</td></tr>
                ) : null}
                {rows.map((row) => (
                  <tr key={row.key} className="app-clickable-row" onClick={() => navigate(`/commission-plans/${encodeURIComponent(row.uid)}`)}>
                    <td className="fw-semibold">{row.name}</td>
                    <td>{row.maxDepth}</td>
                    <td><span className={`badge rounded-pill fw-semibold text-uppercase ${row.isDefault ? 'bg-success-subtle text-success' : 'bg-secondary-subtle text-secondary'}`}>{row.isDefault ? t('common.yes') : t('common.no')}</span></td>
                    <td><span className={`badge rounded-pill fw-semibold text-uppercase ${row.isActive ? 'bg-success-subtle text-success' : 'bg-secondary-subtle text-secondary'}`}>{row.isActive ? t('common.yes') : t('common.no')}</span></td>
                    <td>{row.tierCount}</td>
                    <td>{row.createdAt}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </LoadingContainer>
        </div>
      </div>
    </div>
  );
}

export default CommissionPlansPageView;
